module.exports = __webpack_public_path__ + "img/akira-gold.115282e4.svg";